enum HyperlinkColorEnum {
	grey = 'grey',
	black = 'black',
	white = 'white'
}
export default HyperlinkColorEnum;
